// extracted by mini-css-extract-plugin
module.exports = {"form":"css_form__25SAE","form__color-box":"css_form__color-box__1buFX","form__delete-icon":"css_form__delete-icon__3sA6f"};